import type { WritableSignal } from '@angular/core';
import { InjectionToken, inject, signal } from '@angular/core';
import type { CanDeactivateFn } from '@angular/router';

/** Whether an Antrag is being sent right now; outlives its dialog so the route under it can ask. */
export const ANTRAG_SENDING = new InjectionToken<WritableSignal<boolean>>('AntragSending', {
  providedIn: 'root',
  factory: () => signal(false),
});

/** While an Antrag is being sent the page under its dialog stays, so Back and Forward do nothing. */
export const stayWhileSendingGuard: CanDeactivateFn<unknown> = () => !inject(ANTRAG_SENDING)();
